/*
 * File: MenuKeys.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:04:24 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */
export enum MenuKeys {
  logout = 'Log Out',
  about = 'About'
}

export enum AddressFormMenuKeys {
  BusinessSelection = 'business-selection',
  AddressInformation = 'address-information',
  ContactInformation = 'contact-information'
}
